// extracted by mini-css-extract-plugin
export var dropdown = "_qm-0";
export var imageWrapper = "_qm-3";
export var itemNameContainer = "_qm-1";
export var productImage = "_qm-2";
export var spinnerWrapper = "_qm-4";